<!-- MobileShell Template - Feature: 012-desktop-mobile-shells -->
<div class="mobile-shell">
  <!-- Skip Link for Accessibility -->
  <a href="#main-content" class="skip-link" [attr.aria-label]="'SHELL.SKIP_TO_CONTENT' | translate">
    {{ 'SHELL.SKIP_TO_CONTENT' | translate }}
  </a>

  <!-- Header -->
  <app-header></app-header>

  <!-- Main Content Area -->
  <main id="main-content" class="mobile-shell__content" role="main" tabindex="-1">
    <div class="mobile-shell__content-inner">
      <ng-content></ng-content>
    </div>
  </main>

  <!-- Bottom Navigation -->
  <nav class="mobile-shell__bottom-nav" role="navigation" [attr.aria-label]="'SHELL.BOTTOM_NAVIGATION' | translate">
    <app-bottom-nav></app-bottom-nav>
  </nav>
</div>
